import ACTIONS from '../actions';

const drawerInfoTree = (state = {}, action) => {
    switch (action.type) {
        case ACTIONS.DRAWER_LOAD_INFO:
            return { ...action.data };
        default:
            return state;
    }
};

export default drawerInfoTree;



// WEBPACK FOOTER //
// ./src/state/reducer/calendar/reducer/drawerInfoTree.js